import { baseApi } from './baseApi';
import type { MonedaInfo } from '../../utils/moneda';

/**
 * Las monedas en las que el tenant carga precios: USD + la local de su país. En Uruguay
 * son las dos de siempre; en Ecuador o El Salvador, una sola. Reemplaza a la lista fija
 * `['USD', 'UYU']` que tenían los selectores.
 */
/** El país en el que opera el tenant, resuelto por el backend (`paisDelTenant`). */
export interface PaisDelTenant {
  countryIso:       string;
  countryName:      string;
  siteId:           string;
  currencyId:       string;
  currencySymbol?:  string;
  currencyDecimals: number;
  publica:          boolean;
  /** Centro del país según ML: donde arranca un mapa sin coordenadas. Falta hasta el primer sync. */
  centro?:          { lat: number; lng: number };
  /**
   * ¿Este tenant puede ver la bolsa de captación externa?
   *
   * ⛔ LO DECIDE EL BACKEND, no el front. La regla es "el tenant nativo, o un Booster en un
   * país con bolsa abierta" y vive en `accesoALaBolsa.ts`. Reescribirla acá —aunque sea un
   * `countryIso === 'PY'`— es la lista duplicada que ya nos dejó a JR BROKER con la puerta
   * abierta en el backend y sin pestaña en la pantalla. (10/09/2026)
   */
  bolsaExterna?:    boolean;
}

const monedasApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getMonedasDelTenant: build.query<MonedaInfo[], void>({
      query: () => '/tenant/monedas',
      transformResponse: (r: { data: MonedaInfo[] }) => r.data,
      keepUnusedDataFor: 3600,
    }),
    getPaisDelTenant: build.query<PaisDelTenant, void>({
      query: () => '/tenant/pais',
      transformResponse: (r: { data: PaisDelTenant }) => r.data,
      keepUnusedDataFor: 3600,
    }),
    /** Cotización de REFERENCIA (MercadoLibre) de `from` a la moneda local del tenant. */
    getFxDelTenant: build.query<CotizacionLocal, string>({
      query: (from) => ({ url: '/tenant/fx', params: { from } }),
      transformResponse: (r: { data: CotizacionLocal }) => r.data,
      keepUnusedDataFor: 3600,
    }),
  }),
});

export interface CotizacionLocal {
  from: string;
  to: string;
  rate: number;
  fecha?: string;
  fetchedAt: string;
  monedaLocal: string;
  simbolo?: string;
  decimales: number;
}

export const { useGetMonedasDelTenantQuery, useGetPaisDelTenantQuery, useGetFxDelTenantQuery } = monedasApi;
